import styled, { css } from 'styled-components';

export const Text = styled.div`
    margin: 10px 0;
    font-size: 16px;
    line-height: 1.35;
    letter-spacing: 0.3px;

    ${({ center }) => center && css`
        text-align: center;
    `}

    ${({ lightWeight }) => lightWeight && css`
        font-weight: 300;
    `}

    ${({ noMarginTop }) => noMarginTop && css`
        margin-top: 0;
    `}

    ${({ usualMarginBottom }) => usualMarginBottom && css`
        margin-bottom: 30px;
    `}

    ${({ mini }) => mini && css`
        font-size: 14px;
    `}

    ${({ error }) => error && css`
        color: #f96868;
    `}

    ${({ white }) => white && css`
        color: #fff;
    `}

    ${({ errorBraintree }) => errorBraintree && css`
        margin-bottom: 45px;
        margin-top: -35px;
    `}
`;

export const Wrap = styled.div`
    a {
        color: black;
        text-decoration: underline;
    }

    a:hover,
    a:active,
    a:focus {
        color: #0099ff;
    }
`;
